import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  public loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  public start(): void {
    this.loadingSubject.next(true);
  }

  public stop(): void {
    this.loadingSubject.next(false);
  }
}
